// extracted by mini-css-extract-plugin
export default {"container":"PersonalDoctor_container__Hi5v+","flexWrapper":"PersonalDoctor_flexWrapper__pJYcB"};